<template>
  <div>
    <bg :pcImg='pcBannerImg' :mobileImg='mobileBannerImg'></bg>
    <!-- 内容 -->
    <div class="contact p">

      <div class="contact-head">
        <h2 class="contact-head-title" >{{this.$route.meta.subTitle}}</h2>
        <img class="contact-head-line" src="../assets/img/icon_split.png" alt="分割线">
        <!-- <p class="contact-head-span">联系我们</p> -->
      </div>

      <router-view></router-view>

    </div>
    

  </div>
</template>

<script>
import BG from '../components/common/BG'

export default {
  data() {
    return {
      pcBannerImg: require('../assets/img/two_banner_bg1.jpg'),
      mobileBannerImg: require('../assets/img/two_banner_mobile_bg1.jpg'),
    }
  },
  components: {
    bg:BG
  },

}
</script>

<style lang="scss" scoped>
@import '../assets/css/register.scss';
@import '../assets/css/base.scss';
  .contact {
    text-indent: 0;
    min-height: 500px;
    &-head {
      padding: 30px 0;
      text-align: center;
      &-title {
        font-weight: 700;
        color: #000;
        font-size: 24px;
      }
      &-line {
        // width: 100%;
      }
      &-span {
        font-weight: 600;
        color: #aaa;
      }
    }

  }

  @media screen and (max-width: 768px){
    .contact {
      &-head {
        &-title {
        }
        &-line {
          width: 100%;
        }
      }
    }
  }
</style>